module.exports = (__webpack_require__(11))(179);


//////////////////
// WEBPACK FOOTER
// delegated ./plugins/jobs/web_client/collections/JobCollection.js from dll-reference girder_plugin_jobs
// module id = 58
// module chunks = 0